// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_C6P","cls2":"CollapsedActivityPreview-cls2_V6W CollapsedActivityPreview-cls1_C6P"};